export default {
  insertIf(condition: boolean, obj: any, objElse: any = {}) {
    return condition ? obj : objElse;
  },
};
